export default "__VITE_ASSET__CWKiGVyN__"